module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n  " + _vm._s(_vm.config.note) + " " + _vm._s(_vm.config.octave) + "\n  "), _c('h4', {
    class: {
      'notePlaying': _vm.playing
    }
  }, [_vm._v("\n    " + _vm._s(_vm.config.keyCode) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77954aef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/triggers.vue
// module id = 286
// module chunks = 1